export enum LoginPageType {
  SMB = 'SMB',
  CRASHPLAN = 'CRASHPLAN',
}
